import React from "react";

/**
 * Global Error Boundary
 * Catches errors anywhere in the child component tree and displays a fallback UI
 * Prevents the entire app from crashing due to one error
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error("🔴 React Error Boundary caught an error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, textAlign: "center" }}>
          <h2 style={{ marginBottom: 20 }}>Something went wrong</h2>
          <button 
            onClick={() => window.location.reload()}
            style={{
              padding: "10px 20px",
              fontSize: 16,
              cursor: "pointer",
              marginRight: 10
            }}
          >
            Reload
          </button>
          <button 
            onClick={() => window.location.href = "/dashboard"}
            style={{
              padding: "10px 20px",
              fontSize: 16,
              cursor: "pointer"
            }}
          >
            Go to Dashboard
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
